<mat-toolbar color="primary">
  <img
    *ngIf="employeeName"
    src="assets/logo-white.png"
    alt="iHost Logo"
    class="app-logo"
  />

  <span class="header-left">
    <!-- At 1250px and narrower the nav buttons do not fit beside the name; one menu holds them. -->
    <button
      *ngIf="employeeName"
      mat-icon-button
      class="nav-burger"
      [matMenuTriggerFor]="menuNav"
      aria-label="Menu"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menuNav="matMenu">
      <div class="nav-burger-panel">
        <div class="nav-burger-who">{{ employeeName }}, {{ restaurant }}</div>

        <div class="nav-burger-section">Customers</div>
        <a
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/customers']"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>list</mat-icon>
          <span>Customer list</span>
        </a>
        <a
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/customers/merge']"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>merge</mat-icon>
          <span>Merge customers</span>
        </a>
        <a
          *ngIf="showMergeLogsMenu"
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/customers/merge-logs']"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>history</mat-icon>
          <span>Merge logs</span>
        </a>

        <div class="nav-burger-section">Sources</div>
        <a
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/sources']"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>source</mat-icon>
          <span>Source list</span>
        </a>
        <a
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/sources/merge']"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>merge</mat-icon>
          <span>Merge sources</span>
        </a>

        <div
          *ngIf="showEmailsMenu || showCampaignsMenu"
          class="nav-burger-section"
        >
          Marketing
        </div>
        <a
          *ngIf="showEmailsMenu"
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/emails']"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>email</mat-icon>
          <span>Emails</span>
        </a>
        <a
          *ngIf="showCampaignsMenu"
          mat-menu-item
          class="nav-burger-item"
          [routerLink]="['/campaigns']"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
        >
          <mat-icon>campaign</mat-icon>
          <span>Campaigns</span>
        </a>
      </div>
    </mat-menu>

    <mat-nav-list class="horizontal-nav-list" *ngIf="employeeName">
      <button mat-button class="nav-button" [matMenuTriggerFor]="menuCustomers">
        <mat-icon>people</mat-icon>
        Customers
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menuCustomers="matMenu">
        <div [style.width.px]="200">
          <a
            mat-menu-item
            [routerLink]="['/customers']"
            [routerLinkActive]="'active-link'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <mat-icon>list</mat-icon>
            <span>List</span>
          </a>
          <a
            mat-menu-item
            [routerLink]="['/customers/merge']"
            [routerLinkActive]="'active-link'"
          >
            <mat-icon>merge</mat-icon>
            <span>Merge</span>
          </a>
          <a
            mat-menu-item
            [routerLink]="['/customers/merge-logs']"
            [routerLinkActive]="'active-link'"
            *ngIf="showMergeLogsMenu"
          >
            <mat-icon>history</mat-icon>
            <span>Merge Logs</span>
          </a>
        </div>
      </mat-menu>

      <button mat-button class="nav-button" [matMenuTriggerFor]="menuSources">
        <mat-icon>source</mat-icon>
        Sources
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menuSources="matMenu">
        <div [style.width.px]="200">
          <a
            mat-menu-item
            [routerLink]="['/sources']"
            [routerLinkActive]="'active-link'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <mat-icon>list</mat-icon>
            <span>List</span>
          </a>
          <a
            mat-menu-item
            [routerLink]="['/sources/merge']"
            [routerLinkActive]="'active-link'"
          >
            <mat-icon>merge</mat-icon>
            <span>Merge</span>
          </a>
        </div>
      </mat-menu>

      <button
        *ngIf="showEmailsMenu"
        mat-button
        class="nav-button"
        [routerLink]="['/emails']"
        [routerLinkActive]="'active-link'"
      >
        <mat-icon>email</mat-icon>
        Emails
      </button>

      <button
        *ngIf="showCampaignsMenu"
        mat-button
        class="nav-button"
        [routerLink]="['/campaigns']"
        [routerLinkActive]="'active-link'"
      >
        <mat-icon>campaign</mat-icon>
        Campaigns
      </button>
    </mat-nav-list>
  </span>
  @if (employeeName) {
    <span *ngIf="employeeName" class="header-right">
      <span class="welcome-text">{{ employeeName }}, {{ restaurant }}</span>
      <button mat-raised-button (click)="logout()" color="warn">
        <mat-icon>logout</mat-icon>
        Logout
      </button>
    </span>
  } @else {
    <span class="header-right">
      <button mat-raised-button color="primary" [routerLink]="['/login']">
        <mat-icon>login</mat-icon>
        Login
      </button>
    </span>
  }
</mat-toolbar>
<router-outlet></router-outlet>
